import { Page404 } from '@main/ui';
import { createRoute } from '@tanstack/react-router';

import { signInRoute } from './signin';

export const route404 = createRoute({
  getParentRoute: () => signInRoute,
  path: '$',
  component: Page404,
});
